import { render, staticRenderFns } from "./SyncStudentList.vue?vue&type=template&id=158174e8&scoped=true"
import script from "./SyncStudentList.vue?vue&type=script&lang=js"
export * from "./SyncStudentList.vue?vue&type=script&lang=js"
import style0 from "./SyncStudentList.vue?vue&type=style&index=0&id=158174e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158174e8",
  null
  
)

export default component.exports